module.exports = __webpack_public_path__ + "static/media/arrow-icon.d139b1ec.svg";